import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ChangeCustAccountComponent } from './change-cust-account/change-cust-account.component'
import { MatTabsModule } from '@angular/material/tabs'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { ChangeLegalEntityComponent } from './change-legal-entity/change-legal-entity.component'
import { SpinnerModule } from '@spartacus/storefront'
import { ConfigModule, I18nModule } from '@spartacus/core'
import { environment } from '../../../../environments/environment'

@NgModule({
  declarations: [ChangeCustAccountComponent, ChangeLegalEntityComponent],
  imports: [
    CommonModule,
    MatTabsModule,
    FormsModule,
    ReactiveFormsModule,
    SpinnerModule,
    I18nModule,
    ConfigModule.withConfig({
      i18n: {
        backend: {
          loadPath:
            environment.deployPath + 'assets/i18n-assets/{{lng}}/{{ns}}.json',
          // loadPath: '/_ui/responsive/common/vs-spartacus/assets/i18n-assets/{{lng}}/{{ns}}.json',
        },
        chunks: {
          userData: ['userData'],
        },
      },
    }),
  ],
  exports: [ChangeCustAccountComponent],
})
export class ChangeCustAccountModule {}
